import { render, staticRenderFns } from "./CorrelationDiagramDialog.vue?vue&type=template&id=fe037e18&scoped=true"
import script from "./CorrelationDiagramDialog.vue?vue&type=script&lang=ts"
export * from "./CorrelationDiagramDialog.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationDiagramDialog.vue?vue&type=style&index=0&id=fe037e18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe037e18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe037e18')) {
      api.createRecord('fe037e18', component.options)
    } else {
      api.reload('fe037e18', component.options)
    }
    module.hot.accept("./CorrelationDiagramDialog.vue?vue&type=template&id=fe037e18&scoped=true", function () {
      api.rerender('fe037e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/CorrelationDiagramDialog.vue"
export default component.exports